import GradeFeeList from "@/controllers/grade_fee/grade-fee-list";
import axios from "axios";
import store from '../../../store';
import ValidationService from '@/services/ValidationService';

export default {
    extends: GradeFeeList,
    mixins: [ValidationService],
    methods: {
        searchGradeFee(page = 1) {
            this.search_status = true;
            this.isLoading = true;
            const params = {
                campus_grade_id: this.selectedCampusGrade,
                fromAnnualFee: this.searchData.fromAnnualFee,
                toAnnualFee: this.searchData.toAnnualFee,
                fromTermlyFee: this.searchData.fromTermlyFee,
                toTermlyFee: this.searchData.toTermlyFee,
                fromMonthlyFee: this.searchData.fromMonthlyFee,
                toMonthlyFee: this.searchData.toMonthlyFee,
                campus_id: store.state.user.campus_id,
            };
            this.searchedData = {
                ...params,
                search_status: this.search_status,
            };
            this.isSearched = true;

            axios
                .get("gradeFee/search?page=" + page, {
                    params
                })
                .then((res) => {
                    if (res.data) {
                        this.gradeFeeMasterData = res.data;
                    }
                    this.isLoading = false;
                })
                .catch((error) => {
                    if (error.response?.status === 401) {
                        this.$store.commit("logout");
                        window.location.replace("login");
                    }
                    this.isLoading = false;
                });
        },

        excelDownload() {
            const status = this.isSearched;
            const searchedData = this.searchedData;

            if (!status) {
                this.isSearched = true;
                this.searchedData = {
                    search_status: false,
                }
            } else {
                this.searchedData.search_status = true;
            }

            GradeFeeList.methods.excelDownload.call(this);

            if (!status) this.isSearched = false;
            this.searchedData = searchedData;
        },

        filterFeeAmount(field) {
            let value = this.searchData[field];

            value = value.replace(/[^0-9]/g, '');
            value = value.replace(/^0+/, '');

            this.searchData[field] = value ? parseInt(value) : null;
        },

        showImport() {
            this.$router.push({
                name: "gradeFeeImport"
            });
        },
    },

    mounted() {
        this.isLoading = true;
        this.getCurrentYearGradeFee();
        this.getCampusGradeName();
    },
};
